import {
  createContext,
  useContext,
  useState,
  useEffect,
  type ReactNode,
} from "react";

interface BreadcrumbContextValue {
  customLabel: string | null;
  setCustomLabel: (label: string | null) => void;
}

const BreadcrumbContext = createContext<BreadcrumbContextValue>({
  customLabel: null,
  setCustomLabel: () => {},
});

export function BreadcrumbProvider({ children }: { children: ReactNode }) {
  const [customLabel, setCustomLabel] = useState<string | null>(null);

  return (
    <BreadcrumbContext.Provider value={{ customLabel, setCustomLabel }}>
      {children}
    </BreadcrumbContext.Provider>
  );
}

export function useBreadcrumbCustomLabel(): string | null {
  return useContext(BreadcrumbContext).customLabel;
}

export function useSetBreadcrumb(label: string | null | undefined) {
  const { setCustomLabel } = useContext(BreadcrumbContext);

  useEffect(() => {
    if (label) {
      setCustomLabel(label);
    }
    return () => {
      setCustomLabel(null);
    };
  }, [label, setCustomLabel]);
}
